require('dotenv').config();
module.exports = {
    domain: process.env.REACT_APP_AWS_AUTH_URL,
    scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: process.env.REACT_APP_LOGIN_REDIRECT,
    redirectSignOut: process.env.REACT_APP_SIGNOUT_REDIRECT,
    responseType: 'code'
};
